import {Routes} from '@angular/router';
import {routes as processRoutes} from './processes/processes.routes';
import {routes as documentRoutes} from './documents/documents.routes';

export const routes: Routes = [
  {
    path: 'processes',
    children: processRoutes,
    data: {
      breadcrumb: []
    }
  },
  {
    path: 'documents',
    children: documentRoutes,
    data: {
      breadcrumb: []
    }
  },
];
